import d from 'datascript';
import { noop } from 'svelte/internal';

let finalDb;

function setUpDb() {

    finalDb = d.empty_db({
        "item": {
            ":db/ident": ":item/id",
            ":db/valueType": ":db.type/ref",
            ":db/cardinality": ":db.cardinality/one",
            ":db/doc": "The id of the item"
        },

        "note": {
            ":db/ident": ":note/id",
            ":db/valueType": ":db.type/ref",
            ":db/cardinality": ":db.cardinality/one",
            ":db/doc": "The id of the note"
        },

        "group": {
            ":db/ident": ":group/id",
            ":db/valueType": ":db.type/ref",
            ":db/cardinality": ":db.cardinality/one",
            ":db/doc": "id of the group"
        },

        "tag": {
            ":db/ident": ":tag/name",
            ":db/valueType": ":db.type/ref",
            ":db/cardinality": ":db.cardinality/one",
            ":db/doc": "The name of the tag"
        },

        ":item/id": {
            ":db/unique": ":db.unique/identity",
        },

        ":note/id": {
            ":db/unique": ":db.unique/identity",
        },

        ":group/id": {
            ":db/unique": ":db.unique/identity",
        },

        ":tag/name": {
            ":db/unique": ":db.unique/identity",
        },

        ":source/name": {
            ":db/unique": ":db.unique/identity",
        },

        ":tag/item": {
            ":db/cardinality": ":db.cardinality/many"
        },

        ":tag/note": {
            ":db/cardinality": ":db.cardinality/many"
        },

        ":note/tag": {
            ":db/cardinality": ":db.cardinality/many"
        },

        // ":item/source": {
        //     ":db/cardinality": ":db.cardinality/one"
        // },

        // "taggedWith": {
        //     ":db/ident": ":item:tags",
        //     ":db/valueType": ":db.type/ref",
        //     ":db/cardinality": ":db.cardinality/many"
        // },

        // "fromSource": {
        //     ":db/ident": ":item:source",
        //     ":db/valueType": ":db.type/ref",
        //     ":db/cardinality": ":db.cardinality/one"
        // },

        // "source": {
        //     ":db/ident": ":source/name",
        //     ":db/valueType": ":db.type/ref",
        //     ":db/cardinality": ":db.cardinality/one",
        //     ":db/doc": "url hostname of the source"
        // },

        // "itemGroup": {
        //     ":db/ident": ":item/group",
        //     ":db/valueType": ":db.type/ref",
        //     ":db/cardinality": ":db.cardinality/one"
        // },
    });

    window.d = d;
    // window.finalDB = finalDb
}

function hashTheTag(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1>>>16), 2246822507) ^ Math.imul(h2 ^ (h2>>>13), 3266489909);
    h2 = Math.imul(h2 ^ (h2>>>16), 2246822507) ^ Math.imul(h1 ^ (h1>>>13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1>>>0);
};

// function func(string) {
//     var hash = 0;
//     if (string.length == 0) return hash;
//     for (x = 0; x <string.length; x++) {
//         ch = string.charCodeAt(x);
//         hash = ((hash <<5) - hash) + ch;
//         hash = hash & hash;
//     }
//     return hash;
// }
// var str = "Happymoments"
// console.log(func(str))

let dbId = 0;

// largest identity id is 2147483647

function getHostname(item) {
    let hostname;
    try {
        ({ hostname } = new URL(item.link));
    } catch (e) {
        return hostname;
    }
    return hostname;
}

function getLinkId(item) {
    // hash(item.link || item.textBody) to determine identical items
    if (item.link) {
        return hashTheTag(item.link)
    } else if (item.textBody) {
        return hashTheTag(item.textBody)
    }
}

function lookupRef() {
    db2 = d.db_with(db2, [{":db/id": [":item/id", '10'], ":item/group": '10'}])

    db2 = d.db_with(db2, [{":db/id": [":item/id", '10'], ":item/tag": '#mysql'}])
}

function addItemEntities(itemsDict, subscriptions, tags) {
    if (!finalDb) {
        setUpDb();
    }

    const groupRecords = subscriptions.map((subscription) => ({
        ":group/id": subscription.id
    }));

    const tagRecords = tags.map((tag) => ({
        ":tag/name": tag
    }))

    finalDb = d.db_with(finalDb, [
        ...groupRecords,
        ...tagRecords
    ])

    Object.entries(itemsDict).forEach(([itemID, item]) => {
        const { tags: itemTags, subscriptionID } = item;
        const hostname = getHostname(item);
        const linkIdentifier = getLinkId(item);
        // const tagRecords = [];
        // const sourceRecords = [];
        const itemRecord = {
            ":db/id": ++dbId,
            ":item/id": itemID,
        }

        if (linkIdentifier) {
            itemRecord[":item/link"] = linkIdentifier;
        }
        if (subscriptionID) {
            const subscriptionEntityID = d.q('[:find ?e . :in $ ?groupId :where [?e ":group/id" ?groupId]]', finalDb, String(subscriptionID))
            itemRecord[':item/group'] = subscriptionEntityID
        }

        // if (tags) {
        //     tags.forEach(tag => {
        //         const tagDbId = ++dbId;
        //         const tagRecord = {":db/id": tagDbId, ":tag/name": tag}
        //         if (!('taggedWith' in itemRecord)) {
        //             itemRecord.taggedWith = []
        //         }
        //         itemRecord.taggedWith.push({ ":db/id": tagDbId });
        //         tagRecords.push(tagRecord);
        //     })
        // }

        // take 2 for tags
        if (itemTags) {
            itemTags.forEach(tag => {
                // lets say tags have been created already
                finalDb = d.db_with(finalDb, [{":db/id": [":tag/name", tag], ":tag/item": itemRecord[":db/id"]}])
            })
        }

        if (hostname) {
            // const sourceRecord = {
            //     ":db/id": dbId,
            //     ":source/name": hostname,
            // }
            // if (sourceHashID) {
            //     sourceRecord[":source/hashID"] = sourceHashID
            // }
            // itemRecord.fromSource = {":db/id": dbId};
            // sourceRecords.push(sourceRecord);


            // finalDb = d.db_with(finalDb, [
            //     itemRecord,
            //     {":source/name": hostname},
            //     {":db/id": [":item/id", noteId], ":item/source": hostname }
            // ]);
            itemRecord[":item/source"] = hostname;
        }

        finalDb = d.db_with(finalDb, [itemRecord]);
    });

    window.finalDb = finalDb;
}

function addTaggedEntities(itemTagsMap) {
    if (!finalDb) {
        setUpDb();
    }

    const tagRecords = Object.keys(itemTagsMap).map((tag) => ({
        ":tag/name": tag
    }));

    finalDb = d.db_with(finalDb, [
        ...tagRecords
    ]);

    Object.entries(itemTagsMap).forEach(([tag, notes]) => {

        notes.forEach((note) => {
            const noteId = note.split(':')[2];
            const noteRecord = {":note/id": noteId};
            finalDb = d.db_with(finalDb, [noteRecord, {":db/id": [":note/id", noteId], ":note/tag": tag }])
        });
    });
    window.finalDb = finalDb
}

function addTagsToItem(itemIDs, tagsToAdd) {
    finalDb = d.db_with(finalDb, tagsToAdd.map((tagName) => (
        [{":tag/name": tagName}, ...itemIDs.map((itemID) => ({
            ":db/id": [":tag/name", tagName],
            ":tag/item": [":item/id", itemID]
        }))]
    )).flat())
}

function addItems(items) {
    // item/group

    const records = items.map(item => {
        const { subscriptionID, id } = item;
        const hostname = getHostname(item);
        const linkIdentifier = getLinkId(item);
        // const tagRecords = [];
        // const sourceRecords = [];
        const itemRecord = {
            ":item/id": id,
        }

        if (linkIdentifier) {
            itemRecord[":item/link"] = linkIdentifier;
        }
        if (subscriptionID) {
            const subscriptionEntityID = d.q('[:find ?e . :in $ ?groupId :where [?e ":group/id" ?groupId]]', finalDb, String(subscriptionID))
            itemRecord[':item/group'] = subscriptionEntityID
        }
        if (hostname) {
            itemRecord[":item/source"] = hostname;
        }

        return itemRecord
    });

    finalDb = d.db_with(finalDb, records)
}

// function queryItemsWithTags2(tags) {
//     var q3 = `[:find ?itemId 
//                 :in $ [?tagName ...]
//                 :where 
//             [?tag ":tag/name" ?tagName]
//             [?item "taggedWith" ?tag]
//             [?item ":item/id", ?itemId]]`;

//     return d.q(q3, finalDb, tags)
// }

// take 2 tags
function queryItemsWithTags(tags) {
    return d.q(`[
        :find ?itemId ?linkIdentifier
            :in $ [?tagName ...]
            :where
        [?tag ":tag/name" ?tagName]
        [?tag ":tag/item" ?item]
        [?item ":item/id" ?itemId]
        [?item ":item/link" ?linkIdentifier]
    ]`, finalDb, tags)
}

function queryLinkedItems(itemID) {
    return d.q(`[
        :find ?itemId ?tagName ?linkIdentifier
            :in $ ?initialItemID
            :where
        [?initialItem ":item/id" ?initialItemID]
        [?tag ":tag/item" ?initialItem]
        [?tag ":tag/name" ?tagName]
        [?tag ":tag/item" ?allItem]
        [?allItem ":item/id" ?itemId]
        [?allItem ":item/link" ?linkIdentifier]
    ]`, finalDb, itemID);
}

function queryItemsWithSources(sources) {
    return d.q(`[
        :find ?itemId
            :in $ [?sourceName ...]
            :where
        [?item ":item/source" ?sourceName]
        [?item ":item/id" ?itemId]
    ]`, finalDb, sources)
}

function queryNotesWithTags(tags) {
    return d.q(`[
        :find [?noteId ...]
            :in $ [?tagName ...]
            :where
        [?note ":note/tag" ?tagName]
        [?note ":note/id" ?noteId]
    ]`, finalDb, tags)
}
/**
 * 
 * inputs: https://docs.datomic.com/on-prem/query/query.html#inputs
 */


function queryGroupsWithItem(itemID) {

    const q3 = `[
        :find [?groupId ...]
            :in $ ?itemId
            :where
        [?item ":item/id" ?itemId]
        [?item ":item/link" ?link]
        [?allItems ":item/link" ?link]
        [?allItems ":item/group" ?group]
        [?group ":group/id" ?groupId]
    ]`

    const q4 = `[
        :find ?groupId ?allItemId
            :in $ ?itemId
            :where
        [?item ":item/id" ?itemId]
        [?item ":item/link" ?link]
        [?allItems ":item/link" ?link]
        [?allItems ":item/group" ?group]
        [?group ":group/id" ?groupId]
        [?allItems ":item/id" ?allItemId]
    ]`

    return d.q(q4, finalDb, itemID)
}

function queryAllLinks() {
    const q4 = `[:find [?linkId ...] :where [?link ":link/id" ?linkId]]`;
    return d.q(q4, finalDb);
}

function queryAllItems() {
    var q3 = `[:find ?itemId 
            :in $ 
            :where 
        [?item ":item/id", ?itemId]]`;

    return d.q(q3, finalDb)
}

function queryAllSources() {
    return d.q(`[
        :find [?sourceName ...]
            :where
        [_ ":item/source", ?sourceName]
    ]`, finalDb)
}

function queryAllSourcesWithItemCounts() {
    return d.q(`[
        :find ?sourceName (count ?item)
            :where
        [?item ":item/source" ?sourceName]
    ]`, finalDb)
}

export {
    addItemEntities,
    addTaggedEntities,
    queryItemsWithTags,
    queryLinkedItems,
    queryNotesWithTags,
    queryItemsWithSources,
    queryAllItems,
    queryAllSources,
    queryAllSourcesWithItemCounts,

    addItems,
    addTagsToItem,

    queryGroupsWithItem,
    hashTheTag,
}